// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + ({"265":"canvg","297":"xlsx","643":"pdfmake"}[chunkId] || chunkId) + "." + {"265":"8e7831cc","297":"dfe34bfb","643":"942c51ef","787":"afa46f36","959":"55026374"}[chunkId] + ".chunk.js";
};